<template>
  <div class="carousel">
    <VueSlickCarousel
      v-if="itemsToShow > 0"
      :slidesToShow="slidesToShow"
      @afterChange="afterChange"
      v-bind="slickSettings"
    >
      <slot />
    </VueSlickCarousel>
    <DragScroll v-else>
      <slot />
    </DragScroll>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import { mapGetters } from 'vuex';
import DragScroll from './DragScroll.vue';

export default {
  props: {
    itemsToShow: {
      type: Number,
      default: 0,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    VueSlickCarousel,
    DragScroll,
  },
  computed: {
    ...mapGetters(['windowWidth']),
    slidesToShow () {
      if (this.windowWidth > 1263) {
        return this.itemsToShow || 2;
      }
      if (this.windowWidth > 960) {
        return 3.5;
      }
      if (this.windowWidth > 600) {
        return 2.5;
      }
      return 1.5;
    },
    slickSettings () {
      return {
        arrows: false,
        dots: false,
        infinite: false,
        swipeToSlide: true,
        edgeFriction: 0.35,
        ...this.settings,
      }
    },
  },
  methods: {
    afterChange(slideNumber) {
      this.$emit('afterChange', slideNumber)
    }
  },
};
</script>

<style lang="scss" scoped>
.carousel {
  width: 100%;
}
</style>
